import { render, staticRenderFns } from "./AiB2b.vue?vue&type=template&id=23a90d16&"
import script from "./AiB2b.vue?vue&type=script&lang=js&"
export * from "./AiB2b.vue?vue&type=script&lang=js&"
import style0 from "./AiB2b.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports